import Duties from "@/assets/js/duties";
import Strata from "@/assets/js/strata";
import CentralAttack from "@/assets/js/position/central-attack";
import Flanks from "@/assets/js/position/flanks";
import CentralMidfield from "@/assets/js/position/central-midfield";
import CentralDefence from "@/assets/js/position/central-defence";
import EditablePISet from "@/assets/js/editable-pi-set";
import PISetFacade from "@/assets/js/pi-set-facade";

export default class Position {
  constructor(positionData, possibleRoles) {
    this.centralAttack = new CentralAttack(this);
    this.flanks = new Flanks(this);
    this.centralMidfield = new CentralMidfield(this);
    this.centralDefence = new CentralDefence(this);
    this.filled = false;
    this.possibleRoles = possibleRoles;
    const randomRoleIndex = Math.round(Math.random() * (possibleRoles.length - 1));
    this.selectedRole = possibleRoles[randomRoleIndex];
    this.customInstructions = new EditablePISet();
    this.playerInstructions = new PISetFacade(this);
    
    for (const [key, value] of Object.entries(positionData)) {
      this[key] = value;
    }
  }

  get penetrationScore() {
    let penetrationScore = 0;
    if (this.selectedRole === null) return penetrationScore;

    switch (this.stratum) {
      case Strata.M:
        penetrationScore += 1;
        break;
      case Strata.AM:
        penetrationScore += 2;
        break;
      case Strata.ST:
        penetrationScore += 3;
        break;
      default:
        break;
    }
    
    switch (this.selectedRole.duty) {
      case Duties.defend:
        penetrationScore -= 0.5;
        break;
      case Duties.attack:
        penetrationScore += 0.5;
        break;
      default:
        break;
    }

    penetrationScore += this.playerInstructions.getFurtherForward / 2;
    if (this.playerInstructions.movement < 0) {
      penetrationScore -= 0.5;
    }

    if (this.playerInstructions.makeMoreSurgingForwardRuns) {
      penetrationScore += 0.5;
    }

    if (this.playerInstructions.makeMoreDartingRuns) {
      penetrationScore += 0.5;
    }

    if (this.playerInstructions.dropDeepMore) {
      penetrationScore -= 0.5;
    }

    return Math.min(Math.max(penetrationScore, 0), 4);
  }

  get solidityScore() {
    let solidityScore = 0;
    if (this.selectedRole === null) return solidityScore;

    switch (this.stratum) {
      case Strata.M:
        solidityScore += 1;
        break;
      case Strata.DM:
        solidityScore += 2;
        break;
      case Strata.D:
        solidityScore += 3;
        break;
      default:
        return solidityScore;
    }
    
    switch (this.selectedRole.duty) {
      case Duties.defend:
        solidityScore += 0.5;
        break;
      case Duties.attack:
        solidityScore -= 0.5;
        break;
      default:
        break;
    }

    solidityScore -= this.playerInstructions.getFurtherForward / 2;
    if (this.playerInstructions.movement < 0) {
      solidityScore += 0.5;
    }

    if (this.playerInstructions.makeMoreSurgingForwardRuns) {
      solidityScore -= 0.5;
    }

    if (this.playerInstructions.makeMoreDartingRuns) {
      solidityScore -= 0.5;
    }

    if (this.playerInstructions.dropDeepMore) {
      solidityScore += 0.5;
    }

    return Math.min(Math.max(solidityScore, 0), 4);
  }

  get supportScore() {
    let supportScore = 0,
        positionFactor = 0;
    if (this.selectedRole === null) return supportScore;
    
    switch (this.stratum) {
      case Strata.M:
        supportScore += 3;
        break;
      case Strata.DM:
        supportScore += 2;
        break;
      case Strata.AM:
        supportScore += 2;
        positionFactor = -1;
        break;
      case Strata.D:
        supportScore += 1;
        break;
      case Strata.ST:
        supportScore += 1;
        positionFactor = -1;
        break;
      default:
        return supportScore;
    }
    
    switch (this.selectedRole.duty) {
      case Duties.defend:
        supportScore -= 0.5 * positionFactor;
        break;
      case Duties.attack:
        supportScore += 0.5 * positionFactor;
        break;
      default:
        break;
    }

    supportScore += (this.playerInstructions.getFurtherForward / 2) * positionFactor;
    if (this.playerInstructions.movement < 0) {
      supportScore -= 0.5 * positionFactor;
    }

    if (this.playerInstructions.makeMoreSurgingForwardRuns) {
      supportScore += 0.5 * positionFactor;
    }

    if (this.playerInstructions.makeMoreDartingRuns) {
      supportScore += 0.5 * positionFactor;
    }

    if (this.playerInstructions.dropDeepMore) {
      supportScore -= 0.5 * positionFactor;
    }

    return Math.min(Math.max(supportScore, 0), 4);
  }
}
